/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TerminalSale } from '../models/TerminalSale';
import type { TransactionDetails } from '../models/TransactionDetails';
import { request as __request } from '../core/request';

export class TransactionsVService {

    /**
     * @param billingAccountId
     * @param transactionId
     * @param refundAmount
     * @param sendNotification
     * @returns TransactionDetails Created
     * @throws ApiError
     */
    public static async transactionsVVoidRefund(
        billingAccountId: string,
        transactionId: string,
        refundAmount?: number,
        sendNotification: boolean = false,
    ): Promise<TransactionDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v3/billing-accounts/${billingAccountId}/transactions/${transactionId}/void-refund`,
            query: {
                'refundAmount': refundAmount,
                'sendNotification': sendNotification,
            },
        });
        return result.body;
    }

    /**
     * @param billingAccountId
     * @param requestBody
     * @returns TransactionDetails Created
     * @throws ApiError
     */
    public static async transactionsVTerminalTransaction(
        billingAccountId: string,
        requestBody?: TerminalSale,
    ): Promise<TransactionDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v3/billing-accounts/${billingAccountId}/transactions/terminal`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param billingAccountId
     * @param transactionId
     * @returns any OK
     * @throws ApiError
     */
    public static async transactionsVResendMqTransaction(
        billingAccountId: string,
        transactionId: string,
    ): Promise<any> {
        const result = await __request({
            method: 'POST',
            path: `/api/v3/billing-accounts/${billingAccountId}/transactions/${transactionId}/resend`,
        });
        return result.body;
    }

}